import styled from "styled-components";
import { IconPerson } from "../icon/Icons";

const CommonUserIcon = ({ color, focus }) => {
  return (
    <Wrap $color={color} $focus={focus}>
      <InnerWrap $color={color}>
        <IconPerson />
      </InnerWrap>
    </Wrap>
  );
};

export default CommonUserIcon;

const Wrap = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  border: ${({ $focus, $color }) => ($focus ? `2px solid ${$color}` : null)};
  cursor: pointer;
`;

const InnerWrap = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #fff;
  background-color: ${({ $color }) => $color};
`;
